<template>
  <div class="h-full overflow-hidden">
    <el-table :data="securityToolsData" border stripe class="mt-20px" :height="tableHeight">
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="图片" prop="picturesWorkToolId" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <table-view-img
            :classify="scope.row.classify"
            :imgStr="scope.row.picturesWorkToolId"
          ></table-view-img>
        </template>
      </el-table-column>
      <el-table-column label="试验状态" prop="experimentStatus" width="100">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.experimentStatus !== null"
            size="mini"
            :type="statusListTypes(scope.row.experimentStatus || 0)"
            >{{ statusMap(scope.row.experimentStatus) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="借用状态" width="100" prop="borrowStatus" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            size="mini"
            v-if="scope.row.borrowStatus !== null"
            :type="borrowListTypes(scope.row.borrowStatus)"
            >{{ borrowMap(scope.row.borrowStatus) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="分类" width="120" prop="classify" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ typeMap(scope.row.classify) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="工器具名称"
        width="180"
        prop="name"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="编号" width="180" prop="no" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="型号"
        prop="model"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="试验周期"
        prop="circle"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column label="上次试验日期" width="180" prop="dateLastTrial" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.dateLastTrial && dayjs(scope.row.dateLastTrial).format('YYYY-MM-DD') }}
        </template>
      </el-table-column> -->
      <el-table-column label="试验结论" prop="conclusionTrial" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.conclusionTrial !== null">{{
            resultMap(scope.row.conclusionTrial)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="下次试验日期"
        prop="dateNextTrialReal"
        width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.dateNextTrialReal && dayjs(scope.row.dateNextTrialReal).format('YYYY-MM-DD')
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="保管部门"
        width="180"
        prop="custodialDepartmentText"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="gotoDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="securityToolsTableSizeChange"
      @current-change="securityToolsableCurrentChange"
      :current-page.sync="securityToolsPageConfig.SkipCount"
      :page-size.sync="securityToolsPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="securityToolsPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
  </div>
</template>
<script>
import { borrowListTypes, statusListTypes } from '@/components/safety/enumField/enumTypeMethods'
import dayjs from 'dayjs'
import { WorkToolApi } from '@wiz-api/safety-factor-management'
import { forEach } from 'lodash'
import TableViewImg from '@/components/safety/WizSafetyPage/safetyProductionFactor/TableViewImg'
import utils from '@/components/safety/enumField/utils'

const workToolApi = new WorkToolApi()

export default {
  components: {
    TableViewImg,
  },
  props: {
    orgId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      typeList: [],
      resultList: [],
      statusList: [],
      borrowList: [],
      securityToolsData: [],
      securityToolsPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 75px)'
    },
    typeMap() {
      return (val) => {
        return (
          this.typeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    resultMap() {
      return (val) => {
        return (
          this.resultList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    statusMap() {
      return (val) => {
        return (
          this.statusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    borrowMap() {
      return (val) => {
        return (
          this.borrowList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    borrowListTypes() {
      return (val) => {
        return borrowListTypes(val)
      }
    },
    statusListTypes() {
      return (val) => {
        return statusListTypes(val)
      }
    },
    imgListFilter() {
      return (val) => {
        return this.imgList.filter((item) => {
          return item.value === val
        })[0]?.type
      }
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  async created() {
    await utils.getDataCategory(
      [
        'SafetyFactorManagement.DataCategory.BorrowStatus',
        'SafetyFactorManagement.DataCategory.ToolsType',
        'SafetyFactorManagement.DataCategory.TrialResult',
        'SafetyFactorManagement.DataCategory.TrailStatus',
      ],
      ['borrowList', 'typeList', 'resultList', 'statusList'],
      this
    )
    this.getData()
  },
  methods: {
    gotoDetail(row) {
      this.$router.push({
        path: `${this.basePath}/safety-production-factor/tools-management`,
        query: {
          id: row.id,
        },
      })
    },
    // 奖励考核信息页码改变
    securityToolsTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    securityToolsableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    // 设备设施列表`
    async getData() {
      this.loading = true
      const data = {
        custodialDepartment: this.orgId,
        maxResultCount: this.securityToolsPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.securityToolsPageConfig.SkipCount - 1) *
          this.securityToolsPageConfig.MaxResultCount, // 跳过多少条
      }
      const [err, res] = await workToolApi.pagedListQuery(data)
      if (!err) {
        forEach(res.items, (item) => {
          item.circle = `${item.testCycle}${item.testCycleUnitStr}`
        })
        this.securityToolsData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
  },
}
</script>
